export default function CircleIcon({ className }) {
  return (
    <div
      className={`w-6 h-6 rounded-full border-2 border-lz-ember dark:border-lz-candle bg-white flex items-center justify-center text-lz-ember dark:bg-lz-charcoal ${className}`}
    />
  );
}
